<template>
  <div class="dashboard-main">
    <div class="dashboard-main__left">
      <right-top />
      <right-bottom />
    </div>
    <div class="dashboard-main__right">
      <div class="dashboard-top">
        <top-left />
        <top-right />
      </div>
      <buttom-chart />
    </div>
  </div>
</template>
<script>
import TopLeft from './left/top-left.vue'
export default {
  components: {
    RightTop: () => import('@/components/dashboard/main/right/top.vue'),
    RightBottom: () => import('@/components/dashboard/main/right/bottom.vue'),
    TopLeft: () => import('@/components/dashboard/main/left/top-left.vue'),
    TopRight: () => import('@/components/dashboard/main/left/top-right.vue'),
    ButtomChart: () =>
      import('@/components/dashboard/main/left/buttom-chart.vue'),
  },
}
</script>
